import React, { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeftIcon, ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import PdfFitViewer from "../components/PdfFitViewer";

/**
 * Lector a pantalla completa (sin MainLayout).
 * Usa PdfFitViewer (pdf.js) para evitar el recorte lateral del iframe en mobile.
 */
export default function ConexionSieteLector() {
  const [params] = useSearchParams();
  const pdfUrl = (params.get("u") || "").trim();
  const title = useMemo(
    () => (params.get("t") || "Conexión Siete").trim(),
    [params]
  );

  if (!pdfUrl) {
    return (
      <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-3 bg-black px-6 text-center">
        <p className="text-white/90 text-sm">No hay un PDF para mostrar.</p>
        <Link to="/conexion-siete" className="text-brand-lavender text-sm hover:underline">
          Volver a Conexión Siete
        </Link>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-[#1a1a1a] overflow-hidden">
      <header className="shrink-0 flex items-center justify-between gap-2 px-3 sm:px-4 py-2 bg-black/90 border-b border-white/10">
        <div className="flex items-center gap-2 min-w-0">
          <Link
            to="/conexion-siete"
            className="inline-flex items-center gap-1.5 text-sm text-white/85 hover:text-white shrink-0"
          >
            <ArrowLeftIcon className="h-4 w-4" aria-hidden />
            Salir
          </Link>
          <span className="text-white/25">|</span>
          <h1 className="text-sm text-white truncate font-medium">{title}</h1>
        </div>
        <a
          href={pdfUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-xs text-white/80 hover:text-white px-2 py-1.5 rounded border border-white/20 shrink-0"
        >
          <ArrowDownTrayIcon className="h-4 w-4" aria-hidden />
          <span className="hidden sm:inline">Descargar</span>
        </a>
      </header>

      <main className="flex-1 min-h-0 min-w-0 w-full overflow-hidden">
        <PdfFitViewer pdfUrl={pdfUrl} title={title} />
      </main>
    </div>
  );
}
